/** @jsx jsx */
import PropTypes from 'prop-types'
import { Box, jsx } from 'theme-ui'
import CollapsiblePanel from '~/components/Generic/CollapsiblePanel'

const ContentFaqQuestion = ({ question }) => {
  return (
    <CollapsiblePanel title={question.question.question}>
      <Box
        sx={{
          p: {
            variant: 'text.body2',
            '&:first-of-type': {
              mt: 0,
            },
            '&:last-of-type': {
              mb: 0,
            },
          },
        }}
        dangerouslySetInnerHTML={{
          __html: question.answer.childMarkdownRemark.html,
        }}
      />
    </CollapsiblePanel>
  )
}

ContentFaqQuestion.propTypes = {
  question: PropTypes.shape({
    answer: PropTypes.shape({
      childMarkdownRemark: PropTypes.shape({
        html: PropTypes.string,
      }),
    }),
    question: PropTypes.shape({
      question: PropTypes.string,
    }),
  }),
}

export default ContentFaqQuestion
